import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AppConfigService } from '@core/appconfig.service';
import { SfxService } from '@core/sfx.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ButtonComponent } from '@shared/button/button.component';
import { WistiaWindow } from '@shared/wistia/wistia-window.model';
import { Subscription } from 'rxjs';
import { WistiaService } from '../wistia.service';

@Component({
  selector: 'zbp-branded-wistia',
  templateUrl: './branded-wistia.component.html',
  styleUrls: ['./branded-wistia.component.scss'],
  imports: [CommonModule, ButtonComponent]
})
export class BrandedWistiaComponent implements OnInit, OnDestroy {

  @Input() isModal = false;
  @Input() wistiaCode: string;
  /** Wistia player will be configured to work with the Asset Viewer */
  @Input() isViewer = false;
  @Input() isViewerFullScreen = false;
  @Input() viewerPlayerOptions?: any = {};
  @Output() videoEnded: EventEmitter<void> = new EventEmitter<void>();
  @Output() videoError: EventEmitter<void> = new EventEmitter<void>();
  @Output() videoReady: EventEmitter<void> = new EventEmitter<void>();

  private video: any;
  private subscriptions = new Subscription();

  constructor(
    private activeModal: NgbActiveModal,
    private wistia: WistiaService,
    private sfxService: SfxService,
    private appConfigService: AppConfigService,
  ) {
  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngOnInit(): void {
    if (this.isViewer) {
      this.viewerPlayerOptions.playerColor = '#000000';

      this.subscriptions.add(this.wistia.loadScript()
        .subscribe((loaded) => {
          if (loaded) {
            this.initialize(false, this.viewerPlayerOptions);
          }
        }));
    } else {
      this.subscriptions.add(this.wistia.loadScript()
        .subscribe((loaded) => {
          if (loaded) {
            this.initialize(true);
          }
        }));
    }
  }

  dismiss(): void {
    if (this.isModal) {
      this.activeModal.dismiss();
    }
  }

  private initialize(autoPlay: boolean, playerOptions?: any) {
    const w: WistiaWindow = window;
    w._wq.push({
      id: this.wistiaCode,
      options: { autoPlay, ...playerOptions },
      onHasData: (video) => {
        this.video = video;
        this.video.chrome.focus();
        this.video.chrome.setAttribute('tabindex', '0');

        video.bind('play', () => {
          this.sfxService.stopQueue();
          if (this.appConfigService.isLocalUrl) {
            console.log(`'play' event fired for ${video.name()}`);
          }

          return video.unbind;
        });


        video.bind('end', () => {
          this.video.chrome.setAttribute('video', '-1');
          this.videoEnded.emit();
        });
        video.bind('error', () => {
          this.videoError.emit();
        });
      },
      onReady: () => {
        this.videoReady.emit();
      },
    });
  }
}
